import { render } from "./TermsOfUseForm.vue?vue&type=template&id=da6c0498&lang=true"
import script from "./TermsOfUseForm.vue?vue&type=script&lang=js"
export * from "./TermsOfUseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__